export const Clients = ({ t }) => {
  const items = [...t.clients.list, ...t.clients.list];

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-12 md:mb-16">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-[#183321]/40" />
          <span className="text-xs uppercase tracking-[0.25em] text-[#4A6B53] font-semibold">
            {t.clients.eyebrow}
          </span>
        </div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#183321] font-medium max-w-3xl">
          {t.clients.title}
        </h2>
      </div>

      <div className="relative">
        <div className="flex marquee-track whitespace-nowrap" data-testid="clients-marquee">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-16 md:gap-24 px-8 md:px-12"
            >
              <span className="font-serif text-5xl md:text-7xl lg:text-8xl text-[#183321] font-medium tracking-tight">
                {item}
              </span>
              <span className="w-3 h-3 rounded-full bg-[#C26D5C] shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
